import React, { useState, useEffect } from 'react';
import { getItemsByCategory, addItem, updateCategory, updateItem } from '../api/service';
import { deleteItem } from '../api/service';
import '../App.css'
function CategoryItems({ category, setCategories }) {
  const [items, setItems] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
  const [showEditItemModal, setShowEditItemModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Add/Edit item states
  const [kuName, setKuName] = useState('');
  const [arName, setArName] = useState('');
  const [enName, setEnName] = useState('');
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);

  // Edit category states
  const [editCatKuName, setEditCatKuName] = useState(category.ku_name);
  const [editCatArName, setEditCatArName] = useState(category.ar_name);
  const [editCatEnName, setEditCatEnName] = useState(category.en_name);
  const [editCatImage, setEditCatImage] = useState(null);

  useEffect(() => {
    const fetchItems = async () => {
      setItems(category.items);
    };
    setEditCatKuName(category.ku_name);
    setEditCatArName(category.ar_name);
    setEditCatEnName(category.en_name);
    fetchItems();
  }, [category]);

  const handleAddItem = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('category_id', category.id);
    formData.append('ku_name', kuName);
    formData.append('ar_name', arName);
    formData.append('en_name', enName);
    formData.append('price', price);
    formData.append('description', description);
    if (image) formData.append('image', image);

    try {
      const newItem = await addItem(formData);
      setItems((prev) => [...prev, newItem]);
      resetForm();
    } catch (error) {
      console.error('Failed to add item:', error);
      setError('Failed to add item. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditCategory = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    console.log('FormData values:', { ku_name: editCatKuName, ar_name: editCatArName, en_name: editCatEnName });

    const formData = new FormData();
    formData.append('ku_name', editCatKuName);
    formData.append('ar_name', editCatArName);
    formData.append('en_name', editCatEnName);
    if (editCatImage) formData.append('image', editCatImage);
    formData.append('_method', 'PUT');


    try {
      const updatedCategory = await updateCategory(category.id, formData);
      setCategories(prev => prev.map(cat =>
        cat.id === category.id ? updatedCategory : cat
      ));
      setShowEditCategoryModal(false);
    } catch (error) {
      console.error('Failed to update category:', error);
      setError('Failed to update category. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditItem = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    const formData = new FormData();

    // Make sure to append all required fields
    formData.append('ku_name', kuName);
    formData.append('ar_name', arName);
    formData.append('en_name', enName);
    formData.append('price', price);
    formData.append('description', description);
    formData.append('_method', 'PUT'); // Add this line to force PUT method

    if (image) {
      formData.append('image', image);
    }

    try {
      // Log the form data
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const updatedItem = await updateItem(selectedItem.id, formData);
      setItems(prev => prev.map(item =>
        item.id === selectedItem.id ? updatedItem : item
      ));
      resetForm();
    } catch (error) {
      console.error('Failed to update item:', error);
      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = Object.values(error.response.data.errors)
          .flat()
          .join(', ');
        setError(`Validation errors: ${errorMessages}`);
      } else {
        setError('Failed to update item. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const openEditItemModal = (item) => {
    setSelectedItem(item);
    setKuName(item.ku_name);
    setArName(item.ar_name);
    setEnName(item.en_name);
    setPrice(item.price);
    setDescription(item.description);
    setImage(null);
    setShowEditItemModal(true);
  };
  const openDeletItemModal = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const resetForm = () => {
    setShowAddModal(false);
    setShowEditItemModal(false);
    setSelectedItem(null);
    setKuName('');
    setArName('');
    setEnName('');
    setPrice('');
    setImage(null);
    setError(null);
  };

  return (
    <div>
      <div className='d-flex align-items-center mb-4'>
        <img width={65} height={65} src={category.image_link} alt={category.en_name} className="me-3" />
        <h2 className="m-0">{category.en_name}</h2>
      </div>

      <div>
        <button className="btn btn-success my-3 me-2" onClick={() => setShowAddModal(true)}>
          Add Item
        </button>
        <button className="btn btn-warning my-3" onClick={() => setShowEditCategoryModal(true)}>
          Edit Category
        </button>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="row">
        {items.map((item) => (
          <div key={item.id} className="col-md-4 mb-3 ">
          <div className=" d-flex flex-column card p-2" style={{backgroundColor:"#F9F6ED"}}> {/* Changed to flex-column for vertical stacking */}
            {/* Row for name, price, and image */}
            <div className="d-flex justify-content-between px-2 w-100 mb-2"> {/* Added mb-2 for spacing */}
              <div className="item-details">
                <h3 className="item-name">{item[`en_name`]}</h3>
                <p className="item-price">IQD {item.price.toLocaleString()}</p>
              </div>
              <div className="item-image-container ms-3"> {/* Added ms-3 for spacing between text and image */}
                <img
                  src={item.thumb_link}
                  alt={item[`en_name`]}
                  className="item-image"
                />
              </div>
            </div>
            {/* Row for Edit and Delete buttons */}
            <div className="d-flex justify-content-between px-2 w-100 gap-2 mb-2"> {/* Adjusted to align buttons to the right */}
              <button
                className="btn btn-warning"
                onClick={() => openEditItemModal(item)}
              >
                Edit
              </button>
              <button
                className="btn btn-danger"
                onClick={() => openDeletItemModal(item)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
        ))}
      </div>

      {/* Add Item Modal */}
      {showAddModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Item</h5>
                <button type="button" className="btn-close" onClick={resetForm}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAddItem}>
                  <div className="mb-3">
                    <label htmlFor="kuName" className="form-label">Kurdish Name</label>
                    <input
                      type="text"
                      id="kuName"
                      className="form-control"
                      value={kuName}
                      onChange={(e) => setKuName(e.target.value)}
                      placeholder="Kurdish Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="arName" className="form-label">Arabic Name</label>
                    <input
                      type="text"
                      id="arName"
                      className="form-control"
                      value={arName}
                      onChange={(e) => setArName(e.target.value)}
                      placeholder="Arabic Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="enName" className="form-label">English Name</label>
                    <input
                      type="text"
                      id="enName"
                      className="form-control"
                      value={enName}
                      onChange={(e) => setEnName(e.target.value)}
                      placeholder="English Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="price" className="form-label">Price</label>
                    <input
                      type="number"
                      id="price"
                      className="form-control"
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                      placeholder="Price"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="descripttion" className="form-label">Description</label>
                    <input
                      type="text"
                      id="description"
                      className="form-control"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Description"

                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="image" className="form-label">Image</label>
                    <input
                      type="file"
                      id="image"
                      className="form-control"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-success"
                  >
                    {isLoading ? 'Adding...' : 'Add'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Category Modal */}
      {showEditCategoryModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Category</h5>
                <button type="button" className="btn-close" onClick={() => setShowEditCategoryModal(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleEditCategory}>
                  <div className="mb-3">
                    <label htmlFor="editCatKuName" className="form-label">Kurdish Name</label>
                    <input
                      type="text"
                      id="editCatKuName"
                      className="form-control"
                      value={editCatKuName}
                      onChange={(e) => setEditCatKuName(e.target.value)}
                      placeholder="Kurdish Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editCatArName" className="form-label">Arabic Name</label>
                    <input
                      type="text"
                      id="editCatArName"
                      className="form-control"
                      value={editCatArName}
                      onChange={(e) => setEditCatArName(e.target.value)}
                      placeholder="Arabic Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editCatEnName" className="form-label">English Name</label>
                    <input
                      type="text"
                      id="editCatEnName"
                      className="form-control"
                      value={editCatEnName}
                      onChange={(e) => setEditCatEnName(e.target.value)}
                      placeholder="English Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editCatImage" className="form-label">Image</label>
                    <input
                      type="file"
                      id="editCatImage"
                      className="form-control"
                      onChange={(e) => setEditCatImage(e.target.files[0])}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-success"

                  >
                    {isLoading ? 'Updating...' : 'Update'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Delete Item Modal */}
      {showDeleteModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete Item</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this item?</p>
                <p><strong>{selectedItem?.en_name}</strong></p>

                <button
                  type="button"
                  className="btn btn-danger me-2"
                  onClick={async () => {
                    setIsLoading(true);
                    setError(null);
                    try {
                      await deleteItem(selectedItem.id);
                      setItems((prev) => prev.filter(item => item.id !== selectedItem.id));
                      setShowDeleteModal(false);
                      setSelectedItem(null);
                    } catch (error) {
                      console.error('Failed to delete item:', error);
                      setError('Failed to delete item. Please try again.');
                    } finally {
                      setIsLoading(false);
                    }
                  }}
                >
                  {isLoading ? 'Deleting...' : 'Delete'}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setSelectedItem(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Item Modal */}
      {showEditItemModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Item</h5>
                <button type="button" className="btn-close" onClick={() => {
                  setShowEditCategoryModal(false);
                  setEditCatKuName(category.ku_name);
                  setEditCatArName(category.ar_name);
                  setEditCatEnName(category.en_name);
                  setShowEditItemModal(false);
                  setEditCatImage(null);
                }}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleEditItem}>
                  <div className="mb-3">
                    <label htmlFor="editKuName" className="form-label">Kurdish Name</label>
                    <input
                      type="text"
                      id="editKuName"
                      className="form-control"
                      value={kuName}
                      onChange={(e) => setKuName(e.target.value)}
                      placeholder="Kurdish Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editArName" className="form-label">Arabic Name</label>
                    <input
                      type="text"
                      id="editArName"
                      className="form-control"
                      value={arName}
                      onChange={(e) => setArName(e.target.value)}
                      placeholder="Arabic Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editEnName" className="form-label">English Name</label>
                    <input
                      type="text"
                      id="editEnName"
                      className="form-control"
                      value={enName}
                      onChange={(e) => setEnName(e.target.value)}
                      placeholder="English Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editPrice" className="form-label">Price</label>
                    <input
                      type="number"
                      id="editPrice"
                      className="form-control"
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                      placeholder="Price"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editDescription" className="form-label">Description</label>
                    <input
                      type="text"
                      id="editDescription"
                      className="form-control"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Description"

                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editImage" className="form-label">Image</label>
                    <input
                      type="file"
                      id="editImage"
                      className="form-control"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                    {selectedItem && selectedItem.thumb_link && (
                      <div className="mt-2">
                        <small>Current image:</small>
                        <img
                          src={selectedItem.thumb_link}
                          alt="Current thumbnail"
                          className="d-block mt-1"
                          style={{ maxWidth: '100px' }}
                        />
                      </div>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="btn btn-success"
                  >
                    {isLoading ? 'Updating...' : 'Update'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CategoryItems;